import { useQuery } from 'react-query';

import { getFragnetMilestones as queryFn } from 'api/endPoints/getFragnetMilestones';
import { QueryResponse } from 'api/queries/getMilestoneFragnet.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetSingleMilestoneFragnet = (params: {
    latestVersion?: number;
    taskVersionHashCode?: string | null;
}) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getSingleMilestoneFragnet', params],
        queryFn: () =>
            queryFn({
                latestVersion: params.latestVersion as number,
                taskVersionHashCode: params.taskVersionHashCode,
            }),
        enabled: Boolean(params.latestVersion) && Boolean(params.taskVersionHashCode),
    });
};
